import * as React from 'react';

import cn from 'classnames';

import { Translate } from '@decorators';

import { MultilineText } from '@common/components/MultilineText';

import { IBrandPageProps } from '../../types';
import { BrandColorCard } from '../BrandColorCard';

import * as s from './BrandPaletteScreen.scss';

@Translate('common.containers.Brand.components.BrandPaletteScreen')
export class BrandPaletteScreen extends React.Component<IBrandPageProps> {

	render() {
		const {
			brand: {
				colors: brandColors,
			},
		} = this.props;

		return (
			<div className={s.block}>
				<div className={s.title}>
					{this.t('mainColors')}
				</div>

				<div className={s.mainColors}>
					{brandColors.mainColors.map((colors, index) => (
						<div
							key={index}
							className={cn(s.colorBlock, index ? s.blackBackground : s.whiteBackground)}
						>
							{colors.map((color) => (
								<BrandColorCard
									key={color.values.hex}
									color={color}
									isMainColor={true}
								/>
							))}
						</div>
					))}
				</div>

				<div className={s.title}>
					{this.t('auxColors')}
				</div>

				<div className={s.description}>
					<MultilineText text={this.t('auxColorsDescription')}/>
				</div>

				<div className={s.auxColors}>
					{brandColors.auxColors.map((colors, index) => (
						<div
							key={index}
							className={s.colorBlock}
						>
							{colors.map((color) => (
								<BrandColorCard
									key={color.values.hex}
									color={color}
								/>
							))}
						</div>
					))}
				</div>
			</div>
		);
	}

}
